// extracted by mini-css-extract-plugin
export var StatisticsWrapper = "Statistics-module--StatisticsWrapper--3-UTa";
export var TextContainer = "Statistics-module--TextContainer--Ybb2F";